import { useTranslate } from 'ra-core';
import { CardContent } from '../../../components/ui/card';

export function UnitPerformanceSuggestedTrainingCard() {
  const translate = useTranslate();

  return (
    <CardContent>
      <h2 className="text-xl font-semibold">
        {translate('moonstar.unitPerformance.suggestedTraining.title')}
      </h2>
      <p className="my-8 text-center text-3xl text-muted-foreground">
        {translate('moonstar.unitPerformance.suggestedTraining.comingSoon')}
      </p>
    </CardContent>
  );
}
